const TENCENT_MAP_SCRIPT_ID = 'tencent-map-gl-script'

let loadingPromise: Promise<any> | undefined

declare global {
  interface Window {
    TMap?: any
  }
}

export const loadTencentMap = (key: string): Promise<any> => {
  if (window.TMap) {
    return Promise.resolve(window.TMap)
  }
  if (loadingPromise) {
    return loadingPromise
  }

  loadingPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(
      TENCENT_MAP_SCRIPT_ID,
    ) as HTMLScriptElement | null
    const script = existingScript || document.createElement('script')
    script.id = TENCENT_MAP_SCRIPT_ID
    script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${encodeURIComponent(key)}`
    script.async = true
    script.onload = () => (window.TMap ? resolve(window.TMap) : reject(new Error('TMap missing')))
    script.onerror = () => reject(new Error('Tencent Map script failed to load'))
    if (!existingScript) {
      document.head.appendChild(script)
    }
  }).catch(error => {
    loadingPromise = undefined
    throw error
  })

  return loadingPromise
}
